<template>
  <v-container v-if="!progress">
    <v-card>
      <v-container>
        <v-card-title primary-title>
          <h4>{{ this.parent.name.familyName }}</h4>
          <span>　様のご家庭</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <span class="grey--text">指導生徒</span>
        </v-card-text>
        <v-card-text>
          {{ this.student.name.personalName }}
          <span>　さん</span>
        </v-card-text>
        <v-card-text>
          <span> {{ this.student.grade().toJapanese() }}</span>
          <span>　{{ this.student.genderInJapanese() }}</span>
        </v-card-text>
        <v-card-text>
          <span class="grey--text">時間帯</span>
        </v-card-text>
        <v-card-text>
          {{ offer.lesson.schedule.day + "曜日/" + offer.lesson.schedule.start + "-" + offer.lesson.schedule.end }}
        </v-card-text>
          <v-card-text>
          <span class="grey--text">報酬額</span>
        </v-card-text>
        <v-card-text>
          {{ offer.lesson.wage }}円
        </v-card-text>
        <v-card-text>
          <span class="grey--text">依頼時コメント</span>
        </v-card-text>
        <v-card-text class="line--feed">
          {{ offer.lesson.note }}
        </v-card-text>
        <v-row justify="end">
          <v-card-actions>
            <v-btn
              outlined
              color="primary"
              @click="accept()"
            >
              <v-icon>sentiment_very_satisfied</v-icon>引き受ける
            </v-btn>
            <v-btn
              outlined
              @click="refuse()"
            >
              <v-icon>sentiment_very_dissatisfied</v-icon>見送る
            </v-btn>
          </v-card-actions>
        </v-row>
        <VProgress
          v-model="inProgress"
          :message="'処理中です…'"
        />
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { LessonOfferRepository } from '@/repository/LessonOfferRepository.js'
import { ParentRepository } from '@/repository/ParentRepository.js'
import { AgreeOfferService } from '@/service/lesson/agree-offer.js'
import VProgress from '@/components/organisms/VProgress.vue'

export default {
  name: "LessonRequestCard",
  components: {
    "VProgress": VProgress
  },
  data() {
    return {
      teacher: this.$store.getters.teacher,
      student: null,
      parent: null,
      progress: true,
      inProgress: false
    }
  },
  props:{
    offer: Object,
    sender: Object,
  },
  methods: {
    async accept() {
      this.inProgress = true
      const service = new AgreeOfferService(firestore, this.teacher)
      this.teacher = await service.execute(this.offer.id)
      this.$store.commit("loginAsTeacher", this.teacher)
      this.$emit("removeLessonOffer", this.offer.id)
      this.inProgress = false
    },
    async refuse() {
      await this.offerRepo.disagree(this.offer)
      this.$emit("deleteLessonOffer",this.offer.id)
    }
  },
  created: async function() {
    this.offerRepo = new LessonOfferRepository(firestore)
    const parentRepo = new ParentRepository(firestore)
    this.parent = await parentRepo.get(this.offer.senderId)
    this.student = this.parent.findStudent(this.offer.lesson.studentId)
    this.progress = false
  }
}
</script>
